export default "__VITE_ASSET__BuOIeq$j__"